import { FC } from "react";
import { DashboardLayout } from "../../layouts";
import { SalesLayoutPlanner } from "./SalesLayoutPlanner";

export const SalesLayoutPlannerPage: FC = () => {
    return (
        <DashboardLayout centerChildren="Sales Layout Planner" bodyClassName="m-0">
            <SalesLayoutPlanner />
        </DashboardLayout>
    );
};
